import {EtsyListingStateEnum} from '@coolcolduk/etsy';
import {
  Button,
  ButtonGroup,
  FormControl,
  MenuItem,
  Select,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';

// Define props interface
export interface EtsyListingStateSelectorProps {
  listingState?: EtsyListingStateEnum;
  setListingState: (state?: EtsyListingStateEnum) => void;
}

export default function EtsyListingStateSelector({listingState, setListingState}: EtsyListingStateSelectorProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Stack spacing={2} alignItems="center">
      <Typography variant="subtitle2">Listing State</Typography>
      {isMobile ? (
        <FormControl fullWidth>
          <Select
            value={listingState || ''}
            onChange={(e) => setListingState((e.target.value as EtsyListingStateEnum) || undefined)}
            displayEmpty
          >
            {Object.values(EtsyListingStateEnum).map((state) => (
              <MenuItem key={state} value={state}>
                {state.charAt(0).toUpperCase() + state.slice(1).replace('_', ' ')}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <ButtonGroup variant="contained" aria-label="Etsy listing state button group">
          {Object.values(EtsyListingStateEnum).map((state) => (
            <Button
              key={state}
              onClick={() => setListingState(state)}
              variant={listingState === state ? 'contained' : 'outlined'}
              color={listingState === state ? 'primary' : 'inherit'}
            >
              {state.charAt(0).toUpperCase() + state.slice(1).replace('_', ' ')}
            </Button>
          ))}
        </ButtonGroup>
      )}
    </Stack>
  );
}
